import React, { useState } from "react";
import { useViewport } from 'components/general/useViewPort'
import { getPhaseRSC, getLongEventRSC } from 'helpers/rsc'
import Label from "components/general/Label";
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const Statistics = ({ participant, statsData }) => {
    const { breakPoint } = useViewport();
    const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()
    const [currentMetric, setMetric] = useState("metric")
    let _phase = getPhaseRSC(mirs_rsc);
    const _longevent = getLongEventRSC(mirs_rsc);

    const _units = [
        { rsc: _phase + '000100--', round: 1 }
        , { rsc: _phase + '000200--', round: 2 }
        , { rsc: _phase + '000300--', round: 3 }
        , { rsc: _phase + '000400--', round: 4 }
        , { rsc: _longevent, round: 5 }
    ];

    // remove elements without data
    let filteredData = statsData.filter(d => d?.data?.stats !== undefined)

    return (
        <>
            <ButtonToolbar>
                <div className="ms-auto"></div>
                <ButtonGroupMetric currentMetric={currentMetric} setMetric={setMetric} />
            </ButtonToolbar>
            <table className="table">
                <thead>
                    {getColumns(_units, mirs_discipline)}
                </thead>
                <tbody>
                    {getData(_units, participant, statsData, currentMetric)}
                </tbody>
            </table>
        </>
    );
}

export default Statistics;

const ButtonGroupMetric = ({ currentMetric, setMetric }) => {
    const types = [
        { type: 'metric', label: <Label data="HeaderMetric" /> },
        { type: 'imperial', label: <Label data="HeaderImperial" /> }
    ];

    const handleClick = (e) => {
        setMetric(e.target.value)
    }
    return (
        <ButtonGroup size="sm" className="align-items-end" onClick={handleClick}>
            {types.map((obj, index) => (
                <Button key={`btn-measureunit-${index}`} className="selector" variant="outline-dark" active={currentMetric === obj.type} value={obj.type} >{obj.label}</Button>
            ))}
        </ButtonGroup>
    );
}

function getData(_units, participant, statsData, currentMetric) {
    //metric:true = double value metric/imprerial
    const codes = [
        { type: 'EAGLES', label: <Label data="HeaderEagles" /> },
        { type: 'BIRDIE', label: <Label data="HeaderBirdies" /> },
        { type: 'PAR', label: <Label data="HeaderPar" /> },
        { type: 'BOGEY', label: <Label data="HeaderBogeys" /> },
        { type: 'DBL_BOGEY', label: <Label data="HeaderDoubleBogeys" /> },
        { type: 'FAIRWAY_HITS', label: <Label data="HeaderFairwaysHit" /> },
        { type: 'GREENS_REG', label: <Label data="HeaderGreensInRegulation" /> },
        { type: 'SCRAMBLE', label: <Label data="HeaderScrambling" /> },
        { type: 'PUTTS', label: <Label data="HeaderTotalPutts" /> },
        { type: 'SAND_MADE', label: <Label data="HeaderSandSaves" /> },
        { type: 'DRIVE_DIST', metric: true, label: <Label data="HeaderDrivingDistance" /> },
        { type: 'DRIVE_ACC', metric: true, label: <Label data="HeaderDrivingAccuracy" /> },
        { type: 'APPROACH_GAINED', label: <Label data="HeaderApproachShot" /> },
        { type: 'TEE_GAINED', label: <Label data="HeaderStrokesGainedOfftheTee" /> },
        { type: 'APPROACH_GAINED', label: <Label data="HeaderStrokesGainedApproachtheGreen" /> },
        { type: 'AROUND_GAINED', label: <Label data="HeaderStrokesGainedAroundtheGreen" /> },
        { type: 'PUTTS_GAINED', label: <Label data="HeaderStrokesGainedPutting" /> },
        { type: 'TOTAL_GAINED', label: <Label data="HeaderStrokesGainedTotal" /> },
    ];

    return (
        <>
            {
                codes.map((code) => {
                    return (
                        <>
                            <tr key={code.type}>
                                <td className="text-start text-break-space" scope="row"><strong>{code.label}</strong></td>
                                {
                                    _units.map(unit => {
                                        const unitData = statsData.find(d => d.data?.stats?.find(x => x !== undefined)?.rsc === unit.rsc)?.data
                                        const participantData = unitData?.stats
                                            .find(s => s?.statsCompetitors.find(x => x !== undefined)?.code === participant)
                                            ?.statsCompetitors.find(x => x !== undefined)
                                        const courseData = participantData?.statsItems.find(i => i.code === 'COURSE' && i.pos === "3");
                                        const metricPos = (currentMetric === "metric") ? "0" : "1";
                                        const value = code.metric
                                            ? courseData?.extendedStats.find(s => s.code === code.type && s.pos === metricPos)?.value
                                            : courseData?.extendedStats.find(s => s.code === code.type)?.value

                                        return (
                                            <td className="text-end">{value === undefined ? '' : value}</td>
                                        )
                                    })
                                }
                            </tr>
                        </>
                    )
                })
            }
        </>
    )
}

function getColumns(_units, mirs_discipline) {
    return (
        <tr>
            <td className="text-end">&nbsp;</td>
            {
                _units.map(unit => {
                    return (
                        <th className="text-end" scope="col">

                            {
                                unit.round === 5
                                    ? <Label data={"HeaderTotal"} />
                                    : <Label data={`LabelRound${unit.round}`} sport={mirs_discipline} />
                            }
                        </th>
                    )
                })
            }
        </tr>
    )
}
